module.exports = __webpack_public_path__ + "static/Hello-World-a4bd1513acd34b5be1fde87515586f1a.jpg";